module.exports = __webpack_public_path__ + "media/images/sports_coaching/florian-7eff8a66f9c4bf659d7c81f72217f541.jpg";